module.exports = __webpack_public_path__ + "static/media/r21.310d8007.jfif";